import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { OrderContactAnswersSlice } from './contact-answers-types'

const INITIAL_STATE: OrderContactAnswersSlice = {
  middle_name: '',
  website: '',
  suffix: '',
  company_name: '',
  gender: '',
  pronoun: '',
  prefix: '',
  birthdate: '',
  cellphone: '',
}

const orderContactAnswersSlice = createSlice({
  name: 'contactAnswers',
  initialState: INITIAL_STATE,
  reducers: {
    setValue: (state, action: PayloadAction<OrderContactAnswersSlice>) => {
      return { ...state, ...action.payload }
    },
  },
})

export default orderContactAnswersSlice
